module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/189.cd03a225.png";